import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

export const AuthRedirect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // Check if we have magic link parameters in the URL
    const searchParams = new URLSearchParams(location.search)
    const token_hash = searchParams.get('token_hash')
    const type = searchParams.get('type')
    
    console.log('🔐 AuthRedirect: Checking for magic link params...', {
      path: location.pathname,
      token_hash: token_hash ? 'present' : 'missing',
      type
    })
    
    // If we have magic link parameters, redirect to auth/confirm
    if (token_hash && type === 'email' && location.pathname === '/') {
      console.log('🔐 AuthRedirect: Magic link detected! Redirecting to /auth/confirm...')
      // Preserve the query parameters when redirecting
      navigate(`/auth/confirm${location.search}`, { replace: true })
    }
  }, [location, navigate])

  return <>{children}</>
} 